import { ItemCollection } from "../dto/item/ItemCollection";
export default class AddToCartEvent {
    constructor() {
        this.currency = 'EUR';
        this.itemCollection = new ItemCollection();
    }
    export() {
        return {
            currency: this.currency,
            items: this.itemCollection.export(),
        };
    }
}
